import React from 'react';
import styled from 'styled-components';

const CurrenciesLabelContainer = styled.text`
  width: ${(props) => props.widthContainer}px;
  height: ${(props) => props.height}px;
  pointer-events: none;
  font-size: 12px;
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  font-weight: 600;
  display: flex;
  flex-direction: row;
  align-items: center;
  fill: white;

  .currencyLabelContainer {
    width: 80px;
    height: ${(props) => props.height}px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(31, 43, 55, 0.3);
  }

  .currencyLabelContainer:hover {
    cursor: pointer;
  }

  .localCurrencyLabelContainer {
    background-color: rgba(31, 43, 55, 0.8);
  }

  @media (max-width: 1200px) {
    .currencyLabelContainer {
      width: 40px;
    }
    .rowContainer {
      margin-left: ${(props) =>
        props.value && props.value.localCurrency ? '80px' : '40px'};
    }
  }
`;

const getWidthContainer = (value) => (value && value.localCurrency ? 180 : 80);

const CurrenciesLabel = ({ x, y, width, height, value }) => {
  const widthContainer = getWidthContainer(value);
  return (
    value && (
      <React.Fragment>
        {value.localCurrency && (
          <rect
            y={y}
            x={x + width - 180}
            width={100}
            height={30}
            fill="rgba(31, 43, 55, 0.8)"
          />
        )}
        <rect
          y={y}
          x={x + width - 80}
          width={80}
          height={30}
          fill="rgba(31, 43, 55, 0.3)"
        />
        <CurrenciesLabelContainer
          x={x + width - widthContainer}
          widthContainer={widthContainer}
          height={height}
          y={y + 20}
          value={value}
          className="recharts-text recharts-label"
        >
          {value.localCurrency && (
            <tspan
              width={80}
              dx={25 - String(value.localCurrency.value.toFixed(2)).length * 2}
              className="currencyLabelContainer localCurrencyLabelContainer"
            >
              {value.localCurrency.value.toLocaleString('fr-FR', {
                style: 'currency',
                currency: value.localCurrency.currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
            </tspan>
          )}
          <tspan
            dx={
              value.localCurrency
                ? 60 - String(value.localCurrency.value.toFixed(2)).length * 4
                : 20
            }
            width={80}
            className="currencyLabelContainer"
          >
            {value.value.toLocaleString('fr-FR', {
              style: 'currency',
              currency: value.currency,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}
          </tspan>
        </CurrenciesLabelContainer>
      </React.Fragment>
    )
  );
};

export default CurrenciesLabel;
